var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role === 'ROLE_CONTRACTOR')?_c('ContractorAccountHeader'):_c('ProfessionalAccountHeader')}
var staticRenderFns = []

export { render, staticRenderFns }